<div
  class="fixed bottom-0 right-0 flex items-center gap-2 overflow-hidden rounded-tl bg-neutral-000 px-1 py-1 text-x-small"
  [class.pr-20]="isZendeskBubbleVisible()"
>
  @if (versions().beVersion && !showOnlyFeVersion()) {
    <div class="flex items-center gap-1 border-r pr-2">
      <div>API:</div>
      <div class="flex items-center gap-1">
        <div>{{ versions().beApiVersion }}</div>
        @if (versions().beApiVersion !== versions().feApiVersion) {
          <svg-icon class="text-error-500" key="warning-16" size="md" [appTooltip]="'FE API: ' + versions().feApiVersion" type="error" />
        }
      </div>
    </div>

    <div class="flex items-center gap-1 border-r pr-2">
      <div>BE:</div>
      <div>{{ versions().beVersion }}</div>
    </div>
  }

  <div class="flex items-center gap-1">
    @if (versions().beVersion && !showOnlyFeVersion()) {
      <div>FE:</div>
    }
    <div>{{ versions().feVersion }}</div>
  </div>
</div>
